import { useEffect } from 'react';

import cn from 'classnames';
import type { ReactNode } from 'react';

import { ReactComponent as SpinSvg } from 'assets/images/ui/spin.svg';

import styles from './CryptoSpin.module.scss';

interface CryptoSpinHocProps {
  children: ReactNode;
  loading: boolean;
}

export const Loader = () => (
  <div className={styles.loaderContainer}>
    <div className={styles.loader}>
      <SpinSvg className={styles.loaderIcon} />
    </div>
  </div>
);

export const CryptoSpinHoc = ({ children, loading }: CryptoSpinHocProps) => {
  useEffect(() => {
    document.body.style.overflow = loading ? 'hidden' : 'auto';
  }, [loading]);

  return (
    <div className={cn(styles.spinWrapper, { [styles.active]: loading })}>
      {loading && <Loader />}
      <div className={styles.contentContainer}>{children}</div>
    </div>
  );
};

export default CryptoSpinHoc;
